'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = require('react-apollo');

var _graphqlTag = require('graphql-tag');

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _List = require('./View/List');

var _List2 = _interopRequireDefault(_List);

var _List3 = require('../List');

var _List4 = _interopRequireDefault(_List3);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var ChatRoomsPage = (_temp = _class = function (_ListPage) {
  _inherits(ChatRoomsPage, _ListPage);

  function ChatRoomsPage() {
    _classCallCheck(this, ChatRoomsPage);

    return _possibleConstructorReturn(this, _ListPage.apply(this, arguments));
  }

  ChatRoomsPage.prototype.componentWillMount = function componentWillMount() {
    var chatRoomsConnection = this.context.query.chatRoomsConnection;
    var View = this.props.View;
    this.Renderer = (0, _reactApollo.graphql)((0, _graphqlTag2.default)(chatRoomsConnection))(View);
    _ListPage.prototype.componentWillMount && _ListPage.prototype.componentWillMount.call(this);
  };

  ChatRoomsPage.prototype.setPageMeta = function setPageMeta(meta) {
    return _ListPage.prototype.setPageMeta.call(this, _extends({
      title: "Чат-комнаты"
    }, meta));
  };

  ChatRoomsPage.prototype.render = function render() {
    var _this2 = this;

    var Renderer = this.Renderer;

    var _props = this.props,
        View = _props.View,
        where = _props.where,
        other = _objectWithoutProperties(_props, ['View', 'where']);

    var filters = this.getFilters();
    return _react2.default.createElement(Renderer, _extends({
      where: _extends({}, where, filters)
    }, this.getPaginationParams(), {
      addObject: function addObject() {
        var history = _this2.context.router.history;
        history.push("/chat-rooms/create");
      }
    }, other));
  };

  return ChatRoomsPage;
}(_List4.default), _class.propTypes = _extends({}, _List4.default.propTypes, {
  View: _propTypes2.default.func.isRequired
}), _class.defaultProps = _extends({}, _List4.default.defaultProps, {
  View: _List2.default,
  first: 10
}), _temp);
exports.default = ChatRoomsPage;
module.exports = exports['default'];